// Module
var code = " <sb-app-account ng-if=\"true\"></sb-app-account> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/auth/auth.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;